import { useState, useEffect, useCallback } from 'react';
import { isEmpty, every, values } from 'lodash';

export interface IError {
  isValid?: boolean;
  message?: string;
}

export interface IErrors {
  [key: string]: IError;
}

const checkValidForm = (error: any) => {
  if (isEmpty(error)) {
    return false;
  }
  return every(values(error), { isValid: true });
};

export const useForm = (initial: any, callback: Function, validate: any) => {
  const [values, setValues] = useState<any>(initial);
  const [errors, setErrors] = useState<{ [key: string]: IError }>({});
  const [formValid, setFormValid] = useState<boolean>(false);

  useEffect(() => {
    const results = validate(values);
    setErrors(results);
    setFormValid(checkValidForm(results));
  }, [values, validate]);

  const handleChange = useCallback((event: any) => {
    if (event && event.persist) {
      event.persist();
    }
    setValues((prev: any) => ({ ...prev, [event.target.name]: event.target.value }));
  }, []);

  const patchValue = useCallback((update: any) => {
    setValues((prev: any) => ({ ...prev, ...update }));
  }, []);

  const setValue = useCallback((update: any) => {
    setValues((prev: any) => ({ ...prev, ...update }));

  }, [])

  return { handleChange, values, errors, formValid, patchValue, setValue };
};

export default useForm
